export default [
  {
    name: 'LOPD',
    icon: 'mdi-lock-outline',
    path: '/admin/lopd',
    component: () => import(/* webpackChunkName: "admin-documents" */ './views/AdminLopdList'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
